import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './ProfilePage.module.css';
import { ExternalLink } from '../../components';
import Icons from '../../components/Icons/Icons';

const ContactInfoSection = ({ publicData = {} }) => {
  const { phoneNumber, email, city, country, socialLinks = {} } = publicData;
  const { facebook, linkedin, instagram, whatsapp } = socialLinks;

  return (
    <div className={css.contactInfo}>
      <div className={css.contactBlock}>
        <h3>
          <FormattedMessage id="ProfilePage.contactInfo" />
        </h3>

        {phoneNumber && (
          <div className={css.contentLink}>
            <ExternalLink href={`tel:${phoneNumber}`}>
              <Icons name="phone" /> {phoneNumber}
            </ExternalLink>
          </div>
        )}

        {(city || country) && (
          <div className={css.contentLink}>
            <span>
              <Icons name="map" /> {city}
              {city && country ? ', ' : ''}
              {country}
            </span>
          </div>
        )}

        {email && (
          <div className={css.contentLink}>
            <ExternalLink href={`mailto:${email}`}>
              <Icons name="email" /> {email}
            </ExternalLink>
          </div>
        )}
      </div>

      <div className={css.contactBlock}>
        <h3>
          <FormattedMessage id="ProfilePage.socialMedia" />
        </h3>
        <div className={css.contentSocialLink}>
          {facebook && (
            <div className={css.contentLink}>
              <ExternalLink href={facebook}>
                <Icons name="facebook" />{' '}
                <FormattedMessage id="ProfilePage.follow" defaultMessage="Follow" />
              </ExternalLink>
            </div>
          )}
          {linkedin && (
            <div className={css.contentLink}>
              <ExternalLink href={linkedin}>
                <Icons name="linkedIn" />{' '}
                <FormattedMessage id="ProfilePage.follow" defaultMessage="Follow" />
              </ExternalLink>
            </div>
          )}
          {instagram && (
            <div className={css.contentLink}>
              <ExternalLink href={instagram}>
                <Icons name="instagram" />{' '}
                <FormattedMessage id="ProfilePage.follow" defaultMessage="Follow" />
              </ExternalLink>
            </div>
          )}
          {whatsapp && (
            <div className={css.contentLink}>
              <ExternalLink href={`https://wa.me/${whatsapp}`}>
                <Icons name="whatsapp" />{' '}
                <FormattedMessage id="ProfilePage.message" defaultMessage="Message" />
              </ExternalLink>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactInfoSection;
